module.exports = __webpack_public_path__ + "static/media/vantagetower.8fb0a2b3.png";